// Exoticz Reviews Engine
(function() {
  var dateOrder = {
    'May 2025': 10, 'Apr 2025': 9, 'Mar 2025': 8, 'Feb 2025': 7,
    'Jan 2025': 6,  'Dec 2024': 5, 'Nov 2024': 4, 'Oct 2024': 3,
    'Sep 2024': 2,  'Aug 2024': 1
  };

  function starCount(stars) {
    return (stars.match(/★/g) || []).length;
  }

  function initReviews() {
    var handleEl = document.getElementById('ez-product-handle');
    if (!handleEl) return;
    var PRODUCT_HANDLE = handleEl.getAttribute('data-handle');
    var ALL_REVIEWS = window.EZ_REVIEWS || [];

    function hashSeed(str) {
      var h = 0;
      for (var i = 0; i < str.length; i++) {
        h = Math.imul(31, h) + str.charCodeAt(i) | 0;
      }
      return Math.abs(h);
    }

    function seededRandom(seed) {
      var x = Math.sin(seed) * 10000;
      return x - Math.floor(x);
    }

    function pickReviews(handle, count) {
      var seed = hashSeed(handle);
      var pool = ALL_REVIEWS.slice();
      for (var i = pool.length - 1; i > 0; i--) {
        var j = Math.floor(seededRandom(seed + i) * (i + 1));
        var tmp = pool[i]; pool[i] = pool[j]; pool[j] = tmp;
      }
      return pool.slice(0, count);
    }

    var seed = hashSeed(PRODUCT_HANDLE);
    var counts = [38, 41, 44, 47, 49, 52, 55, 58];
    var ratings = ['4.8', '4.9', '4.9', '4.9', '5.0'];
    var reviewCount = counts[seed % counts.length];
    var rating = ratings[seed % ratings.length];

    var avgEl = document.getElementById('reviews-avg');
    var countEl = document.getElementById('reviews-count');
    var grid = document.getElementById('reviews-grid');
    if (!grid) return;

    if (avgEl) avgEl.textContent = rating;
    if (countEl) countEl.textContent = 'Based on ' + reviewCount + ' reviews';

    var picked = pickReviews(PRODUCT_HANDLE, 15);

    function renderReviews(list) {
      var html = '';
      list.forEach(function(r) {
        html += '<div class="review-card">' +
          '<div class="review-card__top">' +
            '<div class="review-card__avatar">' + r.av + '</div>' +
            '<div class="review-card__meta">' +
              '<div class="review-card__name">' + r.name + '</div>' +
              '<div class="review-card__stars">' + r.stars + '</div>' +
            '</div>' +
            '<div class="review-card__date">' + r.date + '</div>' +
          '</div>' +
          '<div class="review-card__title">' + r.title + '</div>' +
          '<div class="review-card__body">' + r.body + '</div>' +
          '<div class="review-card__verified">&#10004; Verified Purchase</div>' +
        '</div>';
      });
      grid.innerHTML = html;
    }

    renderReviews(picked);

    // Expose filter function globally
    window.filterReviews = function(sort) {
      // Update active button
      document.querySelectorAll('.reviews-filter__btn').forEach(function(btn) {
        btn.classList.toggle('active', btn.getAttribute('data-sort') === sort);
      });

      var sorted = picked.slice();
      if (sort === 'newest') {
        sorted.sort(function(a, b) {
          return (dateOrder[b.date] || 0) - (dateOrder[a.date] || 0);
        });
      } else if (sort === 'oldest') {
        sorted.sort(function(a, b) {
          return (dateOrder[a.date] || 0) - (dateOrder[b.date] || 0);
        });
      } else if (sort === 'highest') {
        sorted.sort(function(a, b) {
          return starCount(b.stars) - starCount(a.stars);
        });
      } else if (sort === 'lowest') {
        sorted.sort(function(a, b) {
          return starCount(a.stars) - starCount(b.stars);
        });
      }
      renderReviews(sorted);
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviews);
  } else {
    initReviews();
  }
})();
